export default __webpack_public_path__ + "static/loader1-15e386878b94f5a09e23bef63bbcf7f1.gif";